import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('bulk_benefits_set', '/bulk_benefits_sets')
const reducer = generator.generate()

export default reducer
